// 极简 history router,避免引 react-router
import { useEffect, useState } from 'react';

export function useHashRoute() {
  // 用 pathname,去掉末尾可能的斜杠(除了根路径)
  const normalize = (p) => {
    if (!p) return '/';
    // 去掉 hash(防止有人还输入 #)
    const h = p.indexOf('#');
    if (h >= 0) p = p.slice(0, h);
    // 去掉 query
    const q = p.indexOf('?');
    if (q >= 0) p = p.slice(0, q);
    if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
    return p || '/';
  };

  const [path, setPath] = useState(() => {
    try {
      return normalize(window.location.pathname + window.location.hash);
    } catch {
      return '/';
    }
  });

  useEffect(() => {
    const onChange = () => {
      try {
        setPath(normalize(window.location.pathname));
      } catch {
        setPath('/');
      }
    };
    // 首次再读一次
    onChange();
    // 浏览器前进/后退
    window.addEventListener('popstate', onChange);
    // 监听自定义 navigate 事件
    window.addEventListener('app:navigate', onChange);
    return () => {
      window.removeEventListener('popstate', onChange);
      window.removeEventListener('app:navigate', onChange);
    };
  }, []);

  return path;
}

export function navigate(path) {
  const current = window.location.pathname;
  if (current === path) return;
  window.history.pushState({}, '', path);
  // 触发我们自己的事件,因为 pushState 不会触发 popstate
  window.dispatchEvent(new CustomEvent('app:navigate'));
  // 滚到顶部(可选,提升体验)
  window.scrollTo(0, 0);
}

// 匹配 path 形如 "/admin/users/:id"
export function matchPath(pattern, path) {
  const ps = pattern.split('/').filter(Boolean);
  const xs = path.split('/').filter(Boolean);
  if (ps.length !== xs.length) return null;
  const params = {};
  for (let i = 0; i < ps.length; i++) {
    if (ps[i].startsWith(':')) params[ps[i].slice(1)] = decodeURIComponent(xs[i]);
    else if (ps[i] !== xs[i]) return null;
  }
  return params;
}
